import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import PropTypes from 'prop-types';
import React, {Component} from 'react';
import moment from 'moment';

import {getLoy3MembershipInfo} from '../selectors/sandos4USelector';
import {
    getAuthenticationAll,
    getAuthenticationFailure,
    getAuthenticationFailureMsg,
    getLoy3AuthToken,
    getLoy3Profile,
    getSSOAuthenticationFailure,
    getUserProfile
} from "../selectors/authentication";
import {getMembershipInfo} from "../actions/sandos4UAction";
import {getBrandDetails, getBrandId, getLanguage} from "../selectors/global";
import {getModals} from '../selectors/modals';
import {globalActions, setTitleId} from '../actions/globalActions';
import {hideModal, showModal} from '../actions/modalsActions';
import {AppLayoutBase} from '../layout';
import DashboardPage from '../pages/Dashboard';
import {getUserBookings} from '../actions/bookingActions';
import {getCurrentBookings} from '../selectors/bookings';
import {finishLoading, getLoading, startLoading} from '../reducers/loading';
import {TOOGLE_BOOKING_FORM} from '../constants';
import {message, Modal} from 'antd';
import {userActions, setInitialModalVisible} from "../actions/authenticationActions";
import {NAV_TITLES} from '../components/AppNav/NavTitle';
import logo from "../assets/img/sandos/logo-black.png";
import { Button } from 'antd';



class SimpleHomeContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            mostRecentPastBooking: null,
            nextUpcomingBooking: null,
        };
        this.loadingBookings = false;
    }

    componentDidMount() {
        this.props.setTitleId(NAV_TITLES.DASHBOARD);
        this.loadRelevantBookings();
    }

    hideInitialModal = () => {
        this.props.setInitialModalVisible(false);
    }

    fetchMember = async () => {
        const {authToken, locale, brandId} = this.props;
        await this.props.getMembershipInfo(authToken, locale, brandId);
    }

    async loadRelevantBookings() {
        this.props.startLoading();
        try {
            if (this.props.authToken) {
                await this.fetchMember();
            }
            if (!this.props.bookings) {
                this.loadingBookings = true;
                const queryParams = new URLSearchParams(this.props.location.search);
                const token = queryParams.get('member_token');
                await this.props.loadBookings(token, this.props.brandId).then(() => {
                    this.loadingBookings = false;
                });
            }
        } finally {
            this.props.finishLoading();
        }
    };

    componentDidUpdate(prevProps) {
        if (this.props.ssoAuthFailure) {
            message.error("SSO Auth failure! ")
            this.props.doLogout()
        }
        // When the bookings are received, we pick those to be displayed in the Dashboard
        if (!prevProps.bookings && this.props.bookings) {
            this.loadRelevantBookings();
        }
    }

    render() {
        return (
                <AppLayoutBase>
                    
                </AppLayoutBase>
        );
    }
}

SimpleHomeContainer.propTypes = {
    locale: PropTypes.string,
    modals: PropTypes.object,
    userProfile: PropTypes.object,
    authToken: PropTypes.string,
    bookings: PropTypes.array,
    loadBookings: PropTypes.func.isRequired,
    brandId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    brandDetails: PropTypes.object,
    loy3Profile: PropTypes.object,
    loy3MembershipInfo: PropTypes.object,
    authFailure: PropTypes.bool,
    ssoAuthFailure: PropTypes.bool,
    authFailureMsg: PropTypes.object,
    showModal: PropTypes.func.isRequired,
    hideModal: PropTypes.func.isRequired,
    user: PropTypes.object,
    getBrandId: PropTypes.func.isRequired,
    getBrandDetails: PropTypes.func.isRequired,
    getMembershipInfo: PropTypes.func.isRequired,
    bookingForm: PropTypes.func.isRequired,
    doLogout: PropTypes.func.isRequired,
};

SimpleHomeContainer.contextTypes = {
    t: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
    locale: getLanguage(state),
    modals: getModals(state),
    userProfile: getUserProfile(state),
    brandId: getBrandId(state),
    brandDetails: getBrandDetails(state),
    loy3MembershipInfo: getLoy3MembershipInfo(state),
    loy3Profile: getLoy3Profile(state),
    authToken: getLoy3AuthToken(state),
    bookings: getCurrentBookings(state),
    authFailure: getAuthenticationFailure(state),
    ssoAuthFailure: getSSOAuthenticationFailure(state),
    authFailureMsg: getAuthenticationFailureMsg(state),
    isLoading: getLoading(state),
    authentication: getAuthenticationAll(state),
});

const mapDispatchToProps = (dispatch) => ({
    showModal: (payload) => dispatch(showModal(payload)),
    hideModal: (payload) => dispatch(hideModal(payload)),
    getBrandId: () => globalActions.getBrandId()(dispatch),
    getBrandDetails: (brandId) => globalActions.getBrandDetails(brandId)(dispatch),
    getMembershipInfo: (authToken, locale, brandId) => getMembershipInfo(authToken, locale, brandId)(dispatch),
    loadBookings: (authToken, brandId) => getUserBookings(authToken, brandId)(dispatch),
    setTitleId: (titleId) => dispatch(setTitleId(titleId)),
    startLoading: (payload) => dispatch(startLoading(payload)),
    finishLoading: (payload) => dispatch(finishLoading(payload)),
    bookingForm: () => dispatch({type: TOOGLE_BOOKING_FORM, payload: true}),
    doLogout: () => userActions.logout()(dispatch),
    setInitialModalVisible: (payload) => dispatch(setInitialModalVisible(payload))
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SimpleHomeContainer));


